import React from 'react'
import type { Document } from '@contentful/rich-text-types'
import type { ComposeComponentBlockQuoteFragment } from '../../../.graphql/generated-types'
import { ContentfulRichText } from '../../components/ContentfulRichText'

export interface BlockQuoteProps {
  data: ComposeComponentBlockQuoteFragment
}

export function BlockQuote({ data }: BlockQuoteProps) {
  if (data.text?.json) {
    return (
      <div
        className="
      flex space-y-4 rounded border-0 before:font-['georgia,garamond,serif'] before:text-6xl before:text-[#652d90]
      before:content-['“'] md:flex-row
      md:space-x-4 md:space-y-0"
      >
        <blockquote className="flex-grow p-6">
          <span className="leading-10">
            <style global jsx>{`
              blockquote h2 {
                margin-bottom: 1rem;
              }
            `}</style>
            <ContentfulRichText
              document={data.text.json as Document}
              entries={data.text.links.entries}
            />
          </span>
        </blockquote>
      </div>
    )
  }
  return null
}
